import styled, { css } from 'styled-components';
import breakpoints from '../breakpoints';
import FormContainer from './FormContainer';
import InvalidMessageIcon from '../images/invalid-message-icon.svg';

const ValidationMessage = styled.div`
  margin: 0.375rem 0 1.625rem;
  color: ${({ theme }) => theme.errorMessageColor || '#cc4749'};
  display: block;
  background-image: url(${InvalidMessageIcon});
  background-repeat: no-repeat;
  font-size: 0.8125rem;
  padding-left: 1.625rem;
  background-position-y: -4px;
  line-height: 1.25;
`;

const FormRow = styled.div`
  width: 100%;

  /* Only apply custom widths when we exceed the breakpoint */
  @media screen and (min-width: ${breakpoints.md}) {
    width: ${({ width }) => (width ? `${width}%` : 'auto')};
  }

  ${({ invalid }) =>
    invalid &&
    css`
      ${FormContainer} & {
        label,
        input,
        select,
        textarea {
          border-color: ${({ theme }) => theme.errorMessageColor || '#cc4749'};
        }
        ${ValidationMessage} {
          display: block;
          color: ${({ theme }) => theme.errorMessageColor || '#cc4749'};
          font-size: 0.8125rem;
        }
      }
    `}
  ${({ valid }) =>
    valid &&
    css`
      ${FormContainer} & {
        label,
        input,
        select,
        textarea {
          color: green;
          border-color: green;
        }
      }
    `};
`;

export { FormRow, ValidationMessage };
